import script from "./PsychiatryRecordTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PsychiatryRecordTable.vue?vue&type=script&setup=true&lang=js"

import "./PsychiatryRecordTable.vue?vue&type=style&index=0&id=e9522496&scoped=true&lang=scss"
script.__scopeId = "data-v-e9522496"

export default script